export const SET_USER_DATA = 'SET_USER_DATA';

export const ALL_SELLPOINTS = 'ALL_SELLPOINTS'
export const ALL_SELLPOINTS_SUCCESS = 'ALL_SELLPOINTS_SUCCESS'
export const USER_SELLPOINTS = 'USER_SELLPOINTS';
export const USER_SELLPOINT = 'USER_SELLPOINT';
export const USER_SELLPOINT_APP_SUB_OFFERS = 'USER_SELLPOINT_APP_SUB_OFFERS';
export const USER_SELLPOINT_SHIPPING = 'USER_SELLPOINT_SHIPPING';
export const USER_SELLPOINT_DISCOUNTS = 'USER_SELLPOINT_DISCOUNTS';
export const SET_SELLPOINT_CATEGORIES = 'SET_SELLPOINT_CATEGORIES';
export const RESET_SELLPOINTS = 'RESET_SELLPOINTS';

export const USER_SELLPOINT_CATEGORIES = 'USER_SELLPOINT_CATEGORIES'
export const USER_SELLPOINT_CATEGORY = 'USER_SELLPOINT_CATEGORY'

export const USER_SELLPOINT_CATEGORY_PRODUCTS = 'USER_SELLPOINT_CATEGORY_PRODUCTS'
export const USER_SELLPOINT_PRODUCTS = 'USER_SELLPOINT_PRODUCTS'
export const USER_SELLPOINT_PRODUCT = 'USER_SELLPOINT_PRODUCT'
export const ALL_PRODUCTS = 'ALL_PRODUCTS'
export const ALL_PRODUCTS_SUCCESS = 'ALL_PRODUCTS_SUCCESS'

export const PRODUCT_BY_ID = 'PRODUCT_BY_ID'
export const PRODUCT_BY_ID_SUCCESS = 'PRODUCT_BY_ID_SUCCESS'

export const VIEW_CART = 'VIEW_CART'
export const ADD_TO_CART = 'ADD_TO_CART'
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART'

export const ERROR_MSG = 'ERROR_MSG'
export const SUCCESS_MSG = 'SUCCESS_MSG'


// WEBPACK FOOTER //
// ./src/store/mutation-types.js